import { UnstyledButton } from '@workramp/ui';
import styled from 'styled-components';

export const LinkOverlay = styled(UnstyledButton)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;

  &:focus:not(:focus-visible) {
    outline: 0;
  }
`;
